<template>
  <section :id class="relative">
    <BlokkliField
      v-slot="{ items }"
      name="field_paragraphs"
      :list="filterNullArray(paragraphs)"
      :should-render-item
      proxy-mode
    >
      <div class="container">
        <ClientOnly>
          <LazyTeaserMapLoader
            :nids="getNids(items)"
            no-route-update
            class="aspect-video"
            :class="{
              'pointer-events-none': isEditing,
            }"
          />
        </ClientOnly>
      </div>
    </BlokkliField>
  </section>
</template>

<script lang="ts" setup>
import type { FieldListItemTyped } from '#blokkli-build/generated-types'
import type { ParagraphAddressListFragment } from '#graphql-operations'
import { notNullish } from '@vueuse/core'
import { filterNullArray } from '~/helpers'

defineProps<ParagraphAddressListFragment>()

const { isEditing, index, siblings } = defineBlokkli({
  bundle: 'address_list',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  options: {
    addressListStyle: {
      type: 'radios',
      label: 'Style',
      default: 'map',
      options: {
        map: 'Map',
      },
    },
  },
})

const id = useParagraphAnchorId(index, siblings)

const { shouldRenderItem } = useParagraphVisiblity()

function getNids(items: FieldListItemTyped[]) {
  return items
    .map((v) => (v.bundle === 'address' ? v.props?.address?.id : null))
    .filter(notNullish)
}
</script>
